import React, { useState, useEffect } from 'react';
import { useGetContactApiQuery, useUpdateContactMutation } from '../../app/faqApi/faqApi';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Button from '../../components/shared/buttons/button';
const Contact = () => {
  const { data: getContact, isLoading, isFetching } = useGetContactApiQuery();
  const [updateContact, { isLoading: isUpdating }] = useUpdateContactMutation();
  
  const [phone, setPhone] = useState('');
  const [contactId, setContactId] = useState('');
console.log(contactId,"contactId");

  useEffect(() => {
    if (getContact?.data) {
      setPhone(getContact.data.number || '');
      setContactId(getContact.data._id || '');
    }
  }, [getContact]);

  const handleUpdate = async () => {
    if (!contactId) return;
    try {
      await updateContact({ contactId, body: {number : phone}  }).unwrap();
    } catch (err) {
      console.error('Update failed:', err);
    }
  };



  return (
    <div>
      <h2>Contact Us</h2>
      <div style={{ maxWidth: '300px', marginBottom: '10px' }}>
        <PhoneInput
          country={'in'}
          value={phone}
          onChange={(value) => setPhone(value)}
        />
      </div>
      <Button 
        onClick={handleUpdate} 
        disabled={isUpdating}
        label= {isUpdating ? 'Updating...' : 'Update Contact'}
      />
    </div>
  );
};

export default Contact;
